import { SearchQueryParamsExt } from '@peerless/data-access/etilize-api-client';
import fetcher, { FetchInput } from '../client';

export type ProductMatch = {
  title: string;
  sku: string;
  thumbnail: string | null;
};

export type ProductSearchResult<TProduct> = {
  count: number;
  keyword: string;
  products: Array<TProduct>;
};

export async function productSearch(
  query: SearchQueryParamsExt,
  init?: RequestInit
): Promise<ProductSearchResult<ProductMatch>> {
  return await fetcher.get('/products/search', query as FetchInput, init);
}

export async function compatibilitySearch(
  query: { locale: string; keyword: string; product: string },
  init?: RequestInit
): Promise<ProductSearchResult<ProductMatch & { text: string; accessory?: ProductMatch }>> {
  return await fetcher.get('/products/compatibility', query, init);
}

export async function competitorSearch(
  query: { locale: string; keyword: string },
  init?: RequestInit
): Promise<ProductSearchResult<ProductMatch & { text: string }>> {
  return await fetcher.get('/products/competitor', query, init);
}

export async function displaySearch(
  query: { locale: string; keyword: string },
  init?: RequestInit
): Promise<ProductSearchResult<{ text: string }>> {
  return await fetcher.get('/products/displays', query, init);
}
